import { ApiBundle } from "components/organisms/paygate"

export function trackAxonEvent(
  eventName: string,
  eventData?: Record<
    string,
    string | number | Record<string, string | number>[]
  >,
) {
  // @ts-ignore
  if (window.axon) {
    // @ts-ignore
    window.axon("track", eventName, eventData)
  }
}

function getAxonItemFromApiBundle(
  bundle: ApiBundle,
  withoutQuantity?: boolean,
) {
  let period = "week"

  if (bundle.name.includes("month")) {
    period = "month"
  } else if (bundle.name.includes("year")) {
    period = "year"
  }

  return {
    item_variant_id: period,
    item_id: bundle.name,
    item_name: `Pure Subscription - ${period}`,
    price: bundle.price,
    ...(!withoutQuantity && { quantity: 1 }),
    item_category_id: 5032,
    image_url: "https://pure.app/assets/pure_landing_preview.png",
  }
}

export function trackViewItemAxonEvent(apiBundles: ApiBundle[]) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push({
    axon_items: undefined,
  })
  // @ts-ignore
  window.dataLayer.push({
    event: "axon_view_item",
    axon_items: !apiBundles.length ? [] : apiBundles.map((i) => getAxonItemFromApiBundle(i)),
    axon_currency: !apiBundles.length ? "USD" : apiBundles[0].currency,
  })
}

export function trackAddToCartAxonEvent(bundle: ApiBundle) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push({
    axon_items: undefined,
  })
  // @ts-ignore
  window.dataLayer.push({
    event: "axon_add_to_cart",
    axon_items: [getAxonItemFromApiBundle(bundle)],
    axon_currency: bundle.currency,
  })
}

export function trackBeginCheckoutAxonEvent(bundle: ApiBundle) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push({
    axon_items: undefined,
  })
  // @ts-ignore
  window.dataLayer.push({
    event: "axon_begin_checkout",
    axon_items: [getAxonItemFromApiBundle(bundle)],
    axon_currency: bundle.currency,
    axon_value: bundle.price,
  })
}

export function trackPurchaseAxonEvent(bundle: ApiBundle, userId: string) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push({
    axon_items: undefined,
  })
  // @ts-ignore
  window.dataLayer.push({
    event: "axon_purchase",
    axon_items: [getAxonItemFromApiBundle(bundle)],
    axon_currency: bundle.currency,
    axon_value: bundle.price,
    axon_transaction_id: `${userId}:${bundle.name}:${Date.now()}`,
    axon_user_id: userId,
  })
}

export function trackSignupAxonEvent(method: string, userId: string) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push({
    event: "axon_sign_up",
    axon_user_id: userId,
    axon_method: method,
  })
}
